import {motion} from 'framer-motion';
import React from 'react';
import {FaAndroid, FaApple, FaExternalLinkAlt} from 'react-icons/fa';
import {projects} from '../utils/projects';
import {fadeIn} from '../variants';

const Work = () => {
  return (
    <section id="work" className="section h-max lg:items-center ">
      <div className="container mx-auto ">
        <div className="flex flex-col  ">
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={'show'}
            viewport={{once: false, amount: 0.2}}
            className="flex-1 flex flex-col gap-y-8 mb-10 lg:mb-0">
            {/* text */}
            <div>
              <h2 className="font-primary text-[32px] mb-6 tracking-[10%] leading-tight text-accent after:bg-accent after:h-px lg:after:w-[300px] after:inline-block after:relative after:w-full lg:after:ml-4 after:mb-2">
                Some Things I’ve Built
              </h2>
              <p className="max-w-lg  mb-6">
                In my current role, I work across the full stack
                — building and maintaining a CRM/NMS platform with Laravel,
                a customer-facing website with Next.js, and two mobile
                applications with React Native and Expo. Here's an overview
                of the projects I actively develop and maintain.
              </p>
              <p className="max-w-lg  mb-10">
                Each project serves a different part of the business, from
                internal network management to customer self-service and
                field operations.
              </p>
              <a href="https://github.com/uyaribrahim" target="blank">
                <button className="btn btn-sm transition-all duration-500">
                  View Github Repositories
                </button>
              </a>
            </div>
            {/* image */}
          </motion.div>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-y-6 gap-x-5 mt-10">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                variants={
                  index % 2 === 0 ? fadeIn('right', 0.3) : fadeIn('left', 0.3)
                }
                initial="hidden"
                whileInView={'show'}
                viewport={{once: false, amount: 0.2}}
                className="max-w-[570px] h-[220px] lg:h-[340px] grid-item group relative overflow-hidden border-2 border-black/30 rounded-xl ">
                <div className="group-hover:bg-black/80 bg-accent/10 w-full h-full absolute z-40 transition-all duration-300"></div>
                {project.image ? (
                  <img
                    className="w-full h-full object-cover group-hover:scale-125 transition-all duration-500 "
                    src={project.image}
                    alt=""
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-accent/30 to-black/60" />
                )}
                <div className="absolute z-50 left-6 right-6 bottom-0 translate-y-full group-hover:translate-y-0 transition-all duration-500 pb-4 overflow-y-auto max-h-[90%]">
                  <span className="text-gradient text-sm">{project.title}</span>
                  <h3 className="text-white font-bold text-[20px] lg:text-[28px] leading-tight mb-2">
                    {project.name}
                  </h3>
                  <p className="text-white/80 text-[13px] lg:text-[14px] leading-[1.4]">
                    {project.content}
                  </p>
                </div>
                {(project.link || project.linkIos) && (
                  <div className="absolute top-4 right-4 flex gap-3 opacity-0 group-hover:opacity-100 transition-all duration-500 z-50">
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-black/60 hover:bg-accent text-white p-2 rounded-full transition-all duration-300">
                        {project.link.includes('play.google.com') ? (
                          <FaAndroid size={18} />
                        ) : (
                          <FaExternalLinkAlt size={16} />
                        )}
                      </a>
                    )}
                    {project.linkIos && (
                      <a
                        href={project.linkIos}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-black/60 hover:bg-accent text-white p-2 rounded-full transition-all duration-300">
                        <FaApple size={18} />
                      </a>
                    )}
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
